import React from "react";
import { Box, Button } from "@mui/material";
import AxionControls from "../../../components/controls/AxionControls";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import IconPicker from "../../../components/icons/iconPicker";

export default function AddEditMachineLabel(props) {
    const onColorChange = (color, colors) => {
        props.onChange({ target: { id: "colorCode", value: colors.hex } });
    }

    return (
        <Box 
            sx={{
                p:1,
                m:1
            }}>
                <Box>
                    <AxionControls.AxionTextBox 
                        name="name"
                        label={<FormattedMessage {...messages.nameColumn} />}
                        value={props.machineLabel.name}
                        onChange={props.onChange}
                    />
                </Box>
                <Box sx={{marginTop: 2}}>
                    <AxionControls.AxionColorPicker  
                        name="colorCode"
                        label={<FormattedMessage {...messages.colorColumnLabel} />}
                        value={props.machineLabel.colorCode}
                        onChange={onColorChange}
                        sx={{width: 400}}
                    />
                </Box>
                <Box>
                    <IconPicker 
                        value={props.machineLabel.iconId}
                        showNoIcon={false}
                        onChange={(newId) => props.onChange({ target: { id: "iconId", value: newId } })}
                    />
                </Box>
                <Box>
                    <Button 
                        variant="contained" 
                        sx={{
                            marginTop: 2,
                            }}
                        onClick={props.handleSave}>
                        <FormattedMessage {...messages.saveButton} />
                    </Button>
                </Box>
        </Box>
    );
}